<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { Icon, Cog6Tooth, XMark } from "svelte-hero-icons";
  import { cx } from "$lib/utils/cx";
  import { liveStore } from "../Automator/store";

  export let value;
  export let label;
  export let isReadonly = false;
  export let isOpen = false;

  const dispatch = createEventDispatcher();

  function handleClick() {
    if (!isReadonly) {
      isOpen = true;

      $liveStore.pushEvent("open_key_value_configurator", {});
    }
  }

  function clearValue() {
    if (!isReadonly) {
      value = null;
      dispatch("change", null);
    }
  }

  function handleModalClose(_payload) {
    isOpen = false;
  }

  onMount(() => {
    const closedRef = $liveStore.handleEvent("key_value_configurator_closed", handleModalClose);

    return () => {
      $liveStore.removeHandleEvent(closedRef);
    };
  });
</script>

<div class="flex flex-col basis-full {isReadonly ? 'opacity-60' : ''}">
  <div aria-label="Select Build" class="w-full flex items-center {$$props.class || ''}">
    <div class="relative w-full">
      <button
        type="button"
        class="flex gap-2 items-center justify-between w-full h-8 text-left rounded p-2 pr-8 text-xs bg-surface-muted border-0 focus:outline-none truncate"
        class:cursor-not-allowed={isReadonly}
        class:focus:ring-2={!isReadonly}
        class:focus:ring-blue-500={!isReadonly}
        on:click={handleClick}
        disabled={isReadonly}
      >
        <span
          class="text-xs text-content-subtle whitespace-nowrap pointer-events-none transition-all truncate"
          class:cursor-not-allowed={isReadonly}
        >
          {label}
        </span>
      </button>

      <Icon
        src={Cog6Tooth}
        class={cx(
          "absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-content-subtle pointer-events-none",
          isReadonly && "opacity-50",
        )}
      />
    </div>
    <button
      type="button"
      class="ml-2 text-content-subtle hover:text-content focus:outline-none"
      on:click={clearValue}
    >
      <Icon src={XMark} class="w-4 h-4" />
    </button>
  </div>
</div>
